<div class="fun-games-picker">
  <button class="back-btn" (click)="goBack()" [attr.aria-label]="currLang === 'ar' ? 'رجوع' : 'Back'">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">
    {{ currLang === 'ar' ? 'ألعاب ممتعة' : 'Fun Games' }}
  </h2>

  <div class="fun-grid">
    <button class="fun-card fun-card--bowling" type="button" (click)="pickBowling()">
      <div class="fun-icon" aria-hidden="true">🎳</div>
      <div class="fun-name">
        {{ currLang === 'ar' ? 'مضمار البولينج' : 'Strike Lane' }}
      </div>
      <div class="fun-sub">
        {{ currLang === 'ar' ? 'بولينج ثلاثي الأبعاد' : '3D Bowling' }}
      </div>
    </button>

    <div class="fun-card fun-card--placeholder"
         [attr.aria-label]="currLang === 'ar' ? 'المزيد قريبًا' : 'More coming soon'">
      <div class="fun-icon" aria-hidden="true">✨</div>
      <div class="fun-name">
        {{ currLang === 'ar' ? 'المزيد قريبًا' : 'More Fun Games' }}
      </div>
      <div class="fun-sub">
        {{ currLang === 'ar' ? 'قريبًا' : 'Coming soon' }}
      </div>
    </div>
  </div>
</div>
